import React, { createContext, useMemo } from 'react';
import { VendorCTATypes, CTABag } from '../../types';

interface CtaProviderProps {
  children: React.ReactNode;
  tier3Ctas: VendorCTATypes;
}

export const CTAContext = createContext<CTABag>({} as CTABag);
const { Provider } = CTAContext;

const CTAProvider: React.FC<CtaProviderProps> = ({ children, tier3Ctas }) => {
  const dataBag = useMemo(
    () => ({
      tier3Ctas,
    }),
    [tier3Ctas],
  );

  return <Provider value={dataBag}>{children}</Provider>;
};

export default CTAProvider;
